import apiFetch from '@scale/frontend-lib/api-fetch';

export async function inviteMember(body: $FIXME): Promise<$FIXME> {
  return apiFetch(null, 'internal/team/inviteMember', {
    method: 'POST',
    body: JSON.stringify(body),
    headers: { 'Content-Type': 'application/json' },
  });
}

export async function inviteMembers(body: $FIXME): Promise<$FIXME> {
  return apiFetch(null, 'internal/team/inviteMembers', {
    method: 'POST',
    body: JSON.stringify(body),
    headers: { 'Content-Type': 'application/json' },
  });
}

export async function removeInvite(body: $FIXME): Promise<$FIXME> {
  return apiFetch(null, 'internal/team/removeInvite', {
    method: 'POST',
    body: JSON.stringify(body),
    headers: { 'Content-Type': 'application/json' },
  });
}

export async function removeMember(body: $FIXME): Promise<$FIXME> {
  return apiFetch(null, 'internal/team/removeMember', {
    method: 'POST',
    body: JSON.stringify(body),
    headers: { 'Content-Type': 'application/json' },
  });
}

export async function setRole(body: $FIXME): Promise<$FIXME> {
  return apiFetch(null, 'internal/team/setRole', {
    method: 'POST',
    body: JSON.stringify(body),
    headers: { 'Content-Type': 'application/json' },
  });
}

export async function setRapidNotifications(body: $FIXME): Promise<$FIXME> {
  return apiFetch(null, 'internal/team/setRapidNotifications', {
    method: 'POST',
    body: JSON.stringify(body),
    headers: { 'Content-Type': 'application/json' },
  });
}
